import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Mail, Lock, Eye, EyeOff } from 'lucide-react';
const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate login process
    setTimeout(() => {
      setIsLoading(false);
      navigate('/');
    }, 1500);
  };
  const handleSSOLogin = (provider: 'google' | 'microsoft') => {
    setIsLoading(true);
    // Simulate SSO login process
    setTimeout(() => {
      setIsLoading(false);
      navigate('/');
    }, 1500);
  };
  return <div className="min-h-screen bg-green-600 flex items-center justify-center p-4" data-id="element-2682">
      <div className="w-full max-w-md" data-id="element-2683">
        {/* Logo and Title */}
        <div className="text-center mb-8" data-id="element-2684">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-2xl shadow-lg mb-4" data-id="element-2685">
            <img src="https://cdn.magicpatterns.com/uploads/w4Sqqi6gRHWGegGAQT2PTG/Greenback_logo_(1).png" alt="Greenback" className="h-10 w-10" data-id="element-2686" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2" data-id="element-2687">Greenback</h1>
          <p className="text-green-100 text-sm" data-id="element-2688">Social Learning Platform</p>
        </div>

        {/* Login Card */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 border border-gray-200" data-id="element-2689">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-2690">
            Accedi alla piattaforma
          </h2>
          <p className="text-sm text-gray-500 mb-6" data-id="element-2691">
            Continua il tuo percorso di apprendimento
          </p>

          <form onSubmit={handleLogin} className="space-y-4" data-id="element-2692">
            {/* Email Input */}
            <div data-id="element-2693">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2694">
                Email
              </label>
              <div className="relative" data-id="element-2695">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" data-id="element-2696" />
                <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full pl-10 pr-4 py-2.5 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-600 focus:border-transparent" style={{
                borderRadius: '100px'
              }} placeholder="nome@esempio.it" required data-id="element-2697" />
              </div>
            </div>

            {/* Password Input */}
            <div data-id="element-2698">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2699">
                Password
              </label>
              <div className="relative" data-id="element-2700">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" data-id="element-2701" />
                <input id="password" type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} className="w-full pl-10 pr-12 py-2.5 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-600 focus:border-transparent" style={{
                borderRadius: '100px'
              }} placeholder="••••••••" required data-id="element-2702" />
                <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600" data-id="element-2703">
                  {showPassword ? <EyeOff className="h-5 w-5" data-id="element-2704" /> : <Eye className="h-5 w-5" data-id="element-2705" />}
                </button>
              </div>
            </div>

            {/* Remember Me & Forgot Password */}
            <div className="flex items-center justify-between text-sm" data-id="element-2706">
              <label className="flex items-center" data-id="element-2707">
                <input type="checkbox" className="h-4 w-4 text-green-600 border-gray-300 rounded focus:ring-green-600" defaultChecked data-id="element-2708" />
                <span className="ml-2 text-gray-600" data-id="element-2709">Ricordami</span>
              </label>
              <a href="#" className="text-green-600 hover:text-green-700 font-medium" data-id="element-2710">
                Password dimenticata?
              </a>
            </div>

            {/* Login Button */}
            <button type="submit" disabled={isLoading} className="w-full bg-green-600 text-white py-2.5 font-medium hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" style={{
            borderRadius: '100px'
          }} data-id="element-2711">
              {isLoading ? 'Accesso in corso...' : 'Accedi'}
            </button>
          </form>

          {/* Divider */}
          <div className="relative my-6" data-id="element-2712">
            <div className="absolute inset-0 flex items-center" data-id="element-2713">
              <div className="w-full border-t border-gray-200" data-id="element-2714"></div>
            </div>
            <div className="relative flex justify-center text-sm" data-id="element-2715">
              <span className="px-4 bg-white text-gray-500" data-id="element-2716">
                Oppure accedi con
              </span>
            </div>
          </div>

          {/* SSO Buttons */}
          <div className="space-y-3" data-id="element-2717">
            <button type="button" onClick={() => handleSSOLogin('google')} disabled={isLoading} className="w-full flex items-center justify-center gap-3 px-4 py-2.5 border border-gray-300 hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" style={{
            borderRadius: '100px'
          }} data-id="element-2718">
              <svg className="h-5 w-5" viewBox="0 0 24 24" data-id="element-2719">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" data-id="element-2720" />
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" data-id="element-2721" />
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" data-id="element-2722" />
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" data-id="element-2723" />
              </svg>
              <span className="text-sm font-medium text-gray-700" data-id="element-2724">
                Google Workspace
              </span>
            </button>

            <button type="button" onClick={() => handleSSOLogin('microsoft')} disabled={isLoading} className="w-full flex items-center justify-center gap-3 px-4 py-2.5 border border-gray-300 hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" style={{
            borderRadius: '100px'
          }} data-id="element-2725">
              <svg className="h-5 w-5" viewBox="0 0 23 23" data-id="element-2726">
                <path fill="#f3f3f3" d="M0 0h23v23H0z" data-id="element-2727" />
                <path fill="#f35325" d="M1 1h10v10H1z" data-id="element-2728" />
                <path fill="#81bc06" d="M12 1h10v10H12z" data-id="element-2729" />
                <path fill="#05a6f0" d="M1 12h10v10H1z" data-id="element-2730" />
                <path fill="#ffba08" d="M12 12h10v10H12z" data-id="element-2731" />
              </svg>
              <span className="text-sm font-medium text-gray-700" data-id="element-2732">
                Microsoft 365
              </span>
            </button>
          </div>

          {/* Help Text */}
          <p className="mt-6 text-center text-xs text-gray-500" data-id="element-2733">
            Non hai un account?{' '}
            <Link to="/register" className="text-green-600 hover:text-green-700 font-medium" data-id="element-2734">
              Registrati
            </Link>
          </p>
        </div>

        {/* Footer */}
        <p className="mt-8 text-center text-xs text-green-100" data-id="element-2735">
          © 2026 Greenback. Tutti i diritti riservati.
        </p>
      </div>
    </div>;
};
export default Login;